import {
  createCoupon,
  getAllCoupons,
  updateCoupon,
  deleteCoupon,
} from "services/couponService";
import {
  getCouponsStart,
  getCouponsSuccess,
  getCouponsFailure,
  createCouponStart,
  createCouponSuccess,
  createCouponFailure,
  updateCouponStart,
  updateCouponSuccess,
  updateCouponFailure,
  deleteCouponStart,
  deleteCouponSuccess,
  deleteCouponFailure,
} from "store/features/coupon/couponSlice";

export const fetchCoupons = () => async (dispatch) => {
  try {
    dispatch(getCouponsStart());
    const response = await getAllCoupons();
    dispatch(getCouponsSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getCouponsFailure(error.message));
    throw error;
  }
};

export const createNewCoupon = (couponData) => async (dispatch) => {
  try {
    dispatch(createCouponStart());
    const response = await createCoupon(couponData);
    dispatch(createCouponSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(createCouponFailure(error.message));
    throw error;
  }
};

export const updateExistingCoupon = (id, updates) => async (dispatch) => {
  try {
    dispatch(updateCouponStart());
    const response = await updateCoupon(id, updates);
    dispatch(updateCouponSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(updateCouponFailure(error.message));
    throw error;
  }
};

export const deleteExistingCoupon = (id) => async (dispatch) => {
  try {
    dispatch(deleteCouponStart());
    const response = await deleteCoupon(id);
    dispatch(deleteCouponSuccess(id));
    return response;
  } catch (error) {
    dispatch(deleteCouponFailure(error.message));
    throw error;
  }
};
